import { Panel, PanelBody, PanelGrid, PanelGridItem, PanelHeader, PanelLink, PanelTitle } from 'components';
import { Link } from 'react-router-dom';
import { useNavigation } from 'hooks';
import { DeductionDetailHeaderData } from 'types/DeductionDetailHeaderData';
import styles from './DeductionDetailsHeader.module.scss';

type Props = {
    deductionDetailHeader: DeductionDetailHeaderData
}

export default function DeductionDetailHeader({ deductionDetailHeader }: Props) {
    const { searchUrl } = useNavigation();

    return (
        <Panel className={styles.panel}>
            <PanelHeader className={styles.header}>
                <PanelLink>
                    <Link to={searchUrl}>Back to Search</Link>
                </PanelLink>
                <div className={styles.heading}>
                    <PanelTitle>{deductionDetailHeader.deductionNumber} | {deductionDetailHeader.vendorId}</PanelTitle>
                </div>
            </PanelHeader>
            <PanelBody className={styles.body}>
                <PanelGrid className={styles.grid}>
                    <div className={styles.gridItem}>
                        <PanelGridItem
                            label={"Customer Number: "}
                            value={<span>{deductionDetailHeader.customerId}</span>}
                        />
                    </div>
                    <div className={styles.gridItem}>
                        <PanelGridItem
                            label={"Customer Name: "}
                            value={<span>{deductionDetailHeader.customerName}</span>}
                        />
                    </div>
                    <div className={styles.gridItem}>
                        <PanelGridItem
                            label={"Claimed For: "}
                            value={<span>Payment #{deductionDetailHeader.paymentIdRef ? deductionDetailHeader.paymentIdRef : " Not Available"}</span>}
                        />
                    </div>
                </PanelGrid>
            </PanelBody>
        </Panel>
    )
}